var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ODataTable',{staticClass:"dense-table",attrs:{"spec":_vm.spec,"items":_vm.filteredRows}})}
var staticRenderFns = []

export { render, staticRenderFns }